import React from 'react';

const SvgCoc = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="COC_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="COC_svg__b">
        <stop stopColor="#19BFBF" offset="0%" />
        <stop stopColor="#10ACAC" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="COC_svg__c" fill="#fff">
        <use xlinkHref="#COC_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#COC_svg__a" />
      <path fill="url(#COC_svg__b)" mask="url(#COC_svg__c)" d="M0 0h28v20H0z" />
      <path
        d="M13.068 3.532c.146-.11.42-.199.599-.199.184 0 .4.133.481.296l.37.742a.598.598 0 0 0 .479.296h1.34a.586.586 0 0 0 .478-.296l.37-.742a.491.491 0 0 0-.092-.536l-.186-.186c-.133-.133-.098-.24.096-.24h.66c.186 0 .413.126.508.284l1.658 2.765c.095.157.254.408.354.559l2.3 3.45c.102.152.184.418.184.602v2.013c0 .18-.083.45-.184.602l-2.3 3.45a.68.68 0 0 1-.51.275H17.66c-.18 0-.442-.096-.59-.219l-3.474-2.896a1.064 1.064 0 0 0-.59-.219h-2.012c-.18 0-.46.067-.628.15l-3.399 1.7a.493.493 0 0 1-.533-.082l-.868-.869a.935.935 0 0 1-.233-.562v-1.34c0-.182-.087-.461-.185-.608l-.963-1.444a.63.63 0 0 1-.032-.584L5.18 7.64a1.17 1.17 0 0 1 .46-.459l2.054-1.027c.169-.085.45-.189.633-.235l2.013-.503c.18-.045.441-.168.592-.28l2.136-1.603zM18 17.333h1.333l-.426.426a.337.337 0 0 1-.481 0L18 17.333z"
        fill="#FFF"
        mask="url(#COC_svg__c)"
      />
    </g>
  </svg>
);

export default SvgCoc;
